export { AdmModuleOrders as default } from './Orders';
